import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname, search]);
  return null;
}
